export const routes = {
  LOGIN_URL: '/login',
  LOGOUT_URL: '/logout',
  RESET_PASSWORD_URL: '/resetpassword',
  CHANGE_PASSWORD_URL: '/changepassword',
  UNAUTHORISED_URL: '/unauthorised',

  BOOKINGS_URL: '/',
  BOOKING_URL: '/booking/:booking_reference',
  BOOKING_ACCOMMODATION_URL: '/booking/:booking_reference/accommodation',
  BOOKING_EXTRAS_URL: '/booking/:booking_reference/extras',
  BOOKING_TRANSPORT_URL: '/booking/:booking_reference/transport',
  BOOKING_TICKET_DETAILS_URL: '/booking/:booking_reference/ticket-details',
  BOOKING_MAKE_PAYMENT_URL: '/booking/:booking_reference/make-payment',
  BOOKING_PAY_IN_FULL_URL: '/booking/:booking_reference/pay-in-full',
  BOOKING_RESALE_URL: '/booking/:booking_reference/resale',
  BOOKING_PAYMENT_PLAN_VIEW_URL: '/booking/:booking_reference/payment-plan',
  BOOKING_PAYMENT_PLAN_CHANGE_PAYMENT_URL:
    '/booking/:booking_reference/payment-plan/change-payment',
  BOOKING_PAYMENT_PLAN_CHANGE_DAY_URL:
    '/booking/:booking_reference/payment-plan/change-day',
  BOOKING_TICKETS_URL: '/booking/:booking_reference/tickets',
  BOOKING_REQUIRED_DATA_URL:
    '/booking/:booking_reference/mandatory-information',
  BOOKING_REQUIRED_DATA_ADDRESS_URL:
    '/booking/:booking_reference/required-data/:customer_id/address/update',
  BOOKING_UPDATE_DELIVERY_URL: '/booking/:booking_reference/delivery/update',
  BOOKING_CONFIRMATION_DOWNLOAD_URL:
    '/api/booking/:booking_reference/downloads/confirmation',

  CART_URL: '/booking/:booking_reference/cart',
  CHECKOUT_URL: '/booking/:booking_reference/checkout',

  // File download endpoint
  DOWNLOAD_URL: '/api/booking/download/:key',

  PROFILE_URL: '/profile',
  PROFILE_PERSONAL_DETAILS_URL: '/profile#personal-details',
  PROFILE_CHANGE_PASSWORD_URL: '/profile#change-password',
  PROFILE_EMERGENCY_CONTACT_URL: '/profile#emergency-contact',
  PROFILE_ADDRESS_BOOK_URL: '/profile#address-book',
  PROFILE_DETAILS_BANK_ACCOUNT: '/profile/details/bank-account',
  PROFILE_DETAILS_PASSPORT: '/profile#passport-details',
  SINGLE_ACCOMMODATION_URL:
    '/booking/:booking_reference/accommodation/:accommodation_id',

  ERROR_URL: '/error',
  NOT_FOUND_URL: '/404',
};
